/**
 * Session keys copied main window → localStorage (popout_*) → popout sessionStorage.
 * Must run before axios interceptor and before CADAuth reads sessionStorage.
 */
export const POPOUT_SESSION_KEY_NAMES = [
  'access_token',
  'refresh_token',
  'is-login',
  'AgencyID',
  'PINID',
  'UniqueUserID',
  'SessionTimeOut',
  'IPAddress',
  'IsSuperadmin',
];

(function restorePopoutAuth() {
  const token = localStorage.getItem('popout_access_token');
  if (!token) return;

  POPOUT_SESSION_KEY_NAMES.forEach((key) => {
    const v = localStorage.getItem(`popout_${key}`);
    if (v !== null) {
      sessionStorage.setItem(key, v);
    }
  });

  if (!sessionStorage.getItem('is-login')) {
    sessionStorage.setItem('is-login', 'true');
  }
})();
